<template>
  <div>

    <div class="top-box">
      <span v-html="$t('togetherWork')"></span>
    </div>

    <div class="container">
      <p>{{$t('resumeEmail')}}</p>
      <el-tabs>
        <el-tab-pane :label="$t('backendType')">
          <div v-for="(item, index) in jobsList.backendClass"
               :key="index"
               class="job-container">
                <img src="../assets/avatar.png"/>
                <div class="job-content">
                  <span class="job-title">{{item.title}}</span>
                  <span class="job-address">{{item.address}}</span>
                  <ul>
                    <li v-for="(jd, index) in item.desc" :key="index" class="job-desc">{{jd}}</li>
                  </ul>
                </div>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="$t('androidType')">
          <div v-for="(item, index) in jobsList.androidClass"
               :key="index"
               class="job-container">
                <img src="../assets/avatar.png"/>
                <div class="job-content">
                  <span class="job-title">{{item.title}}</span>
                  <span class="job-address">{{item.address}}</span>
                  <ul>
                    <li v-for="(jd, index) in item.desc" :key="index" class="job-desc">{{jd}}</li>
                  </ul>
                </div>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="$t('dataType')">
          <div v-for="(item, index) in jobsList.dataClass"
               :key="index"
               class="job-container">
                <img src="../assets/avatar.png"/>
                <div class="job-content">
                  <span class="job-title">{{item.title}}</span>
                  <span class="job-address">{{item.address}}</span>
                  <ul>
                    <li v-for="(jd, index) in item.desc" :key="index" class="job-desc">{{jd}}</li>
                  </ul>
                </div>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="$t('productType')">
          <div v-for="(item, index) in jobsList.productClass"
               :key="index"
               class="job-container">
                <img src="../assets/avatar.png"/>
                <div class="job-content">
                  <span class="job-title">{{item.title}}</span>
                  <span class="job-address">{{item.address}}</span>
                  <ul>
                    <li v-for="(jd, index) in item.desc" :key="index" class="job-desc">{{jd}}</li>
                  </ul>
                </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <fix-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer';
import jobList from '@/util/job-list.js';
import enjobList from '@/util/enjob-list.js';

export default {

  data(){
    return{
      jobsList: {}
    }
  },

  created(){
    const locale = localStorage.getItem('locale');
    if(locale === 'zh'){
      this.jobsList = jobList;
    }else{
      this.jobsList = enjobList;
    }
  },

  watch: {
    '$i18n.locale'(){
      const locale = localStorage.getItem('locale');
      if(locale === 'zh'){
        this.jobsList = jobList;
      }else{
        this.jobsList = enjobList;
      }
    }
  },
  
  components: {
    'fix-footer': Footer,
  }

}
</script>

<style lang="less" scoped>

.container{
  padding: 30px 350px;
  box-sizing: border-box;
  background-color: rgb(240, 240, 240);
  margin: 0;

  p{
    text-align: left;
    color: #4F93FF;
    font-size: 40px; /*px*/
    line-height: 1.5;
    margin-top: 35px;
  }

  /deep/ .el-tabs__item{
    font-size: 35px;/*px*/
  }

  /deep/ .el-tabs__nav-scroll{
    margin: 20px auto;
    height: 50px;/*px*/
    overflow: visible;
  }
}

.top-box{
  height: 340px; /*px*/
  background: url('../assets/joinus_bg.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 40px 0;
  box-sizing: border-box;

  span{
    color: #fff;
    font-size: 50px; /*px*/
    line-height:70px;/*px*/
  }
}

.job-container{

  display: flex;
  flex-direction: row;
  background-color: #fff;
  box-shadow:6px 4px 15px 0px rgba(0,0,0,0.05);
  margin-bottom: 50px;
  border-radius:23px;

  img{
    width: 100px;
    height: 100px;
    margin-left: 40px;
    margin-top: 40px;
    object-fit: contain;
  }


  .job-content{
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 40px;
    padding: 50px 20px 50px 0;

    .job-title{
      font-size: 30px; 
      color: #000;
    }
    .job-address{
      font-size: 20px; 
      color: #3B86FE;
      margin-top: 30px;
    }
    .job-desc{
      font-size: 20px; 
      color: #646464;
      line-height:45px;
      margin-top: 30px;
    }
  }
} 

</style>


// WEBPACK FOOTER //
// src/pages/Joinus.vue